import {
  FaBell,
  FaBullhorn,
  FaGavel,
  FaHouse,
  FaPeopleGroup,
  FaShieldHalved,
  FaStore,
  FaTriangleExclamation,
  FaTruckRampBox,
  FaUserGear,
} from 'react-icons/fa6'

export const adminNav = [
  { id: 'overview', label: 'Overview', icon: <FaHouse /> },
  { id: 'auctions', label: 'Auctions', icon: <FaGavel /> },
  { id: 'shop', label: 'Buy Now', icon: <FaStore /> },
  { id: 'orders', label: 'Orders', icon: <FaTruckRampBox /> },
  { id: 'users', label: 'Users', icon: <FaPeopleGroup /> },
  { id: 'consignments', label: 'Consignments', icon: <FaUserGear /> },
  { id: 'content', label: 'Homepage', icon: <FaBullhorn /> },
  { id: 'notifications', label: 'Notifications', icon: <FaBell /> },
  { id: 'risk', label: 'Risk & Relist', icon: <FaTriangleExclamation /> },
  { id: 'settings', label: 'Settings', icon: <FaShieldHalved /> },
]

export const commandActions = [
  { id: 'auctions', label: 'Create Auction', icon: <FaGavel />, detail: 'Timed, reserve, increment, auction type' },
  { id: 'shop', label: 'New Buy-Now', icon: <FaStore />, detail: 'Fixed price, quick checkout, bundle eligible' },
  { id: 'content', label: 'Feature Item', icon: <FaBullhorn />, detail: 'Homepage carousel and spotlight control' },
  { id: 'notifications', label: 'Send Alert', icon: <FaBell />, detail: 'Outbid, drop, checkout, announcement' },
]

export const adminPermissionPresets = {
  full: ['*'],
  ops: ['auctions:write', 'listings:write', 'orders:write', 'consignments:write', 'notifications:write', 'media:write', 'reports:export'],
  reports: ['reports:export'],
}

const adminDescriptions = {
  overview: 'A practical control room for managing auctions, buy-now inventory, orders, users, consignments, homepage features, notifications, and relisting.',
  auctions: 'Create timed auctions, set reserve prices, configure bid increments, schedule lots, upload images, and choose anti-snipe or hard-close behavior.',
  shop: 'Manage fixed-price cards and memorabilia with quick checkout and weekly bundle eligibility.',
  orders: 'Track purchases, auction wins, unpaid orders, shipping status, Friday checkout, and relist risk.',
  users: 'Verify bidders, review saved payment status, manage customer profiles, and monitor account risk.',
  consignments: 'Track consignor intake, professional listing setup, sale status, and manual payout status.',
  content: 'Control homepage carousel, featured auction slots, buy-now spotlights, drops, and admin announcements.',
  notifications: 'Send outbid alerts, auction ending alerts, winning notifications, checkout reminders, new drops, and announcements.',
  risk: 'Manage unpaid wins, penalty automation, reminder queues, and relist operations.',
  settings: 'Configure platform rules, admin permissions, bidder verification, anti-snipe timing, and notification defaults.',
}

export function getAdminDescription(section) {
  return adminDescriptions[section] || adminDescriptions.overview
}
